/* eslint-disable no-param-reassign */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

const VetsterScrollbar = (() => {
  const defaultOptions = {
    wheelPropagation: true,
    maxScrollbarLength: 120,
    updateOnResizeDeep: false,
    updateOnResize: false,
  };
  let observer = null;
  const state = new WeakMap();

  return {
    inserted(el, binding) {
      el.style.position = 'relative';
      const options = { ...defaultOptions, ...binding.value };
      const ps = new PerfectScrollbar(el, options);

      if (window.ResizeObserver) {
        observer = new ResizeObserver(() => {
          ps.update();
        });

        if (options.updateOnResizeDeep) {
          observer.observe(el.firstChild);
        }
        if (options.updateOnResize) {
          observer.observe(el);
        }
      }

      state.set(el, ps);
    },
    unbind(el) {
      const ps = state.get(el);
      ps.destroy();
      state.delete(el);
      observer?.disconnect();
      observer = null;
    },
  };
})();

export default VetsterScrollbar;
